module.exports = __webpack_public_path__ + "h5/img/live-logo.4d3dbb95.gif";